module.exports = __webpack_public_path__ + "ee6ac766/img/splash-icon.07a7c465.svg";